import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { firstValueFrom } from 'rxjs';
import { AppConsts } from '../../AppConsts';
import { ServiceDto, ServicePagedRequestDto, ServiceService } from 'src/app/proxy/services';

@Component({
  selector: 'app-service-selector',
  standalone: false,
  templateUrl: './service-selector.component.html',
})
export class ServiceSelectorComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() serviceIdSelected: number | undefined;
  @Input() isDisabled = false;

  @Output() changeSelectedService = new EventEmitter<ServiceDto>();
  services: ServiceDto[];
  servicesFiltered: ServiceDto[];
  selectedService: ServiceDto;

  constructor(
    injector: Injector,
    private readonly _serviceService: ServiceService, 
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadServices();
    this.onSelected();
  }

  async loadServices(): Promise<void> {
    try {
      this.showLoading();

      const inputDto: ServicePagedRequestDto = {
        name: undefined,
        maxResultCount: AppConsts.MaxPageSize,
        skipCount: 0,
        vendorId: undefined,
        externalSystemIds: undefined
      };

      this.services = (await firstValueFrom(this._serviceService.getAllByInput(inputDto)))?.items || [];
      this.servicesFiltered = this.services;
    } finally {
      this.hideLoading();
    }
  }

  onSelected(): void {
    this.changeSelectedService.emit(this.selectedService);
  }

  async setSelectedServiceById(serviceId: number): Promise<void> {
    this.serviceIdSelected = serviceId;

    if (this.isNullOrUndefined(this.services)) {
      await this.loadServices();
    }
    
    this.setSelectedService();
  }

  filterByVendorId(vendorId: number): void {
    this.servicesFiltered = this.services;
    this.servicesFiltered = this.services?.filter(service => service?.vendorId === vendorId);
    this.setSelectedService();
  }

  private setSelectedService(): void {
    if (this.servicesFiltered?.length) {
      this.selectedService = this.servicesFiltered.find(x => x.id === this.serviceIdSelected);
      this.onSelected();
    }
  }
}